import React from 'react'
import { Table, TableBody } from '@monthio/react-components'
import { TransactionRow } from './TransactionRow'
import styled from 'styled-components'
import { Transaction } from '../../../types/budgetApi.types'

const TableWrapper = styled.div`
	overflow: auto;
`

const StyledTableBody = styled(TableBody)`
	& tr:first-child {
		border-top: none;
	}

	& tr {
		cursor: pointer;
	}

	& td {
		padding: 16px 4px;
	}
`

const columnGroup = (columnWidths: string[]) => {
	return (
		<colgroup>
			{columnWidths.map((width, i) => (
				<col width={width} key={`COLUMN::${i}`} />
			))}
		</colgroup>
	)
}

export const TransactionsTable: React.FC<{
	transactions?: Transaction[]
	selectedTransactionId?: string
	columnWidths: string[]
	onRowClick?: (transaction: Transaction) => void
}> = ({ transactions, selectedTransactionId, columnWidths, onRowClick }) => {
	return (
		<TableWrapper>
			<Table>
				{columnGroup(columnWidths)}
				<StyledTableBody>
					{transactions?.map((transaction) => (
						<TransactionRow
							key={transaction.transactionId}
							selectedTransactionId={selectedTransactionId}
							transaction={transaction}
							onRowClick={onRowClick}
						/>
					))}
				</StyledTableBody>
			</Table>
		</TableWrapper>
	)
}
